import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { AxiosError } from 'axios';

import api from '../../../api/axios';
import { IApiResponseError, IApiState } from '../../../types/api';
import { RootState } from '../..';

export interface IGetWithdrawnCommissionsResponse {
  status?: boolean;
  message?: string;
  data?: {
    id?: string;
    commissionAccountNumber?: string;
    recipientAccountName?: string;
    recipientAccountNumber?: string;
    narration?: string;
    amount?: number;
    transactionDate?: string;
    reference?: string;
    status?: string;
    responseMessage?: string;
  }[];
  meta?: {
    perPage?: number;
    totalPages?: number;
    total?: number;
    page?: number;
  };
  errors?: IApiResponseError;
}

const initialState: IApiState<IGetWithdrawnCommissionsResponse> = {
  value: null,
  status: 'idle',
  error: '',
};

export const getWithdrawnCommissionsAsync = createAsyncThunk(
  'withdrawnCommissions/get',
  async (commissionNumber: string, { rejectWithValue, dispatch, getState }) => {
    try {
      const state = getState() as RootState;

      const accessToken = state.auth.value?.data?.token?.accessToken;
      const businessId = localStorage.getItem('businessId');

      const config = {
        headers: {
          Authorization: `Token ${accessToken}`,
          'X-Business-Id': businessId,
        },
      };

      const { data } = await api.get(
        `/commission/transactions/withdrawals/${commissionNumber}`,
        config
      );

      return data;
    } catch (err) {
      const error = err as AxiosError<IGetWithdrawnCommissionsResponse>;

      return rejectWithValue(error.response?.data);
    }
  }
);

export const withdrawnCommissionsFetch = createSlice({
  name: 'withdrawnCommissions/fetch',
  initialState,
  reducers: {
    resetWithdrawnCommissions: (state) => {
      state.value = null;
      state.status = 'idle';
      state.error = '';
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(getWithdrawnCommissionsAsync.pending, (state) => {
        state.status = 'loading';
        state.error = '';
      })
      .addCase(getWithdrawnCommissionsAsync.fulfilled, (state, action) => {
        state.status = 'success';
        state.value = action.payload as IGetWithdrawnCommissionsResponse;
      })
      .addCase(getWithdrawnCommissionsAsync.rejected, (state, action) => {
        state.status = 'failed';
        state.value = action.payload as IGetWithdrawnCommissionsResponse;
        state.error = action.error.message;
      });
  },
});

export const { resetWithdrawnCommissions } = withdrawnCommissionsFetch.actions;
export default withdrawnCommissionsFetch.reducer;
